import { NgModule } from '@angular/core';
import {
  AuthGuard,
  DynamicLayoutComponent,
  PermissionGuard,
  CoreModule,
  ReplaceableRouteContainerComponent,
  ReplaceableComponents,
} from '@abp/ng.core';
import { Routes, RouterModule } from '@angular/router';
import { TerminalManagementComponent } from './components/terminal-management/terminal-management.component';
import { AppModuleManagementComponent } from './components/app-module-management/app-module-management.component';
import { TerminalLogComponent } from './components/terminal-log/terminal-log.component';
import { eTerminalManagementComponents } from './enums';

const routes: Routes = [
  { path: '', redirectTo: 'terminals', pathMatch: 'full' },
  {
    path: '',
    component: DynamicLayoutComponent,
    canActivate: [AuthGuard, PermissionGuard],
    children: [
      {
        path: 'terminals',
        component: TerminalManagementComponent,
        data: {
          requiredPolicy: 'TerminalManagement.Management',
          replaceableComponent: {
            key: eTerminalManagementComponents.TerminalManagement,
            defaultComponent: TerminalManagementComponent,
          } as ReplaceableComponents.RouteData<TerminalManagementComponent>
        }
      },
      {
        path: 'app-modules',
        component: AppModuleManagementComponent,
        data: {
          requiredPolicy: 'TerminalManagement.AppModuleManagement',
          replaceableComponent: {
            key: eTerminalManagementComponents.AppModuleManagementComponent,
            defaultComponent: AppModuleManagementComponent,
          } as ReplaceableComponents.RouteData<AppModuleManagementComponent>
        }
      },
      {
        path: 'logs',
        component: TerminalLogComponent,
        data: {
          requiredPolicy: 'TerminalManagement.TerminalLog',
          replaceableComponent: {
            key: eTerminalManagementComponents.TerminalLogs,
            defaultComponent: TerminalLogComponent,
          } as ReplaceableComponents.RouteData<TerminalLogComponent>
        }
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class TerminalManagementRoutingModule { }
